import { render, staticRenderFns } from "./ColumnAddToCart.vue?vue&type=template&id=3951900d&scoped=true"
import script from "./ColumnAddToCart.vue?vue&type=script&lang=js"
export * from "./ColumnAddToCart.vue?vue&type=script&lang=js"
import style0 from "./ColumnAddToCart.vue?vue&type=style&index=0&id=3951900d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3951900d",
  null
  
)

export default component.exports